module.exports = __webpack_public_path__ + "img/letsplay.755738e8.png";